import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ArrowBottomRightIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M4.96 6.98L6.3 5.64L15.88 15.24V7.36H17.72V18.4H6.68V16.56H14.52L4.96 6.98Z" />
    </SvgIcon>
  );
});
